<template>
  <div>
    <ul class="pagination pagination-sm pull-left" style="margin-top: 6px; font-style: italic; color: #337ab7" v-if="PAGINATOR.length">
      <p>
        {{$t('paginator.showing')}} {{start}} - {{end}} {{$t('paginator.of')}} {{total}} {{$t('paginator.records')}}
      </p>
    </ul>
    <ul class="pagination pagination-sm no-margin pull-right" v-if="PAGINATOR.length">
      <li v-bind:class="{disabled: PAGE_ARROW.prev===null}" @click="onPrevPagination"><a>&laquo;</a></li>
      <li
        v-for="(page, index) in PAGINATOR"
        :key="index"
        :value="page.value"
        @click="onPagination(page.value)"
        :class="{ active: page.target }"
      > 
        <a>{{ page.text }}</a>
      </li>
      <li v-bind:class="{disabled: PAGE_ARROW.next===null}"  @click="onNextPagination"><a>&raquo;</a></li>

    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Paginator',

  props: {
    item: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      commit_function: null
    }
  },

  watch: {
    item: function(){
      this.create()
    },
  },

  computed: {
    ...mapGetters([
      "PAGINATOR",
      "PAGINATION",
      "PAGE_ARROW"
    ]),

    targetPaginator: function() {
      return this.PAGINATOR.filter(v => v.target)[0]
    },
    start(){
      return 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size
    },
    end(){
      const maxPage = Math.floor((this.PAGINATION.total - 1) / this.PAGINATION.size) + 1
      if (this.PAGINATION.page < maxPage) {
        return this.PAGINATION.size + (this.PAGINATION.page - 1) * this.PAGINATION.size
      }
      return this.PAGINATION.total
    },
    total(){
      return this.PAGINATION.total
    }
  },

  methods: {
    ...mapActions([
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE"
    ]),
    create() {
      this.commit_function = this.item.commit_function
    },
    onPrevPagination: function() {
      if (this.PAGE_ARROW.prev === null) {return}
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_function: this.commit_function,
        page: this.targetPaginator.value - 1
      };
      this.PAGINATION_PREV_PAGE(data)

    },
    onNextPagination: function() {
      if (this.PAGE_ARROW.next === null) {return}
      const data = {
        url: this.PAGE_ARROW.next,
        commit_function: this.commit_function,
        page: this.targetPaginator.value + 1
      };
      this.PAGINATION_NEXT_PAGE(data)

    },
    onPagination: function(value) {
      if (value === 0) return false;
      const data = {
        params: {
              page: value,
        }
      };
      this.$emit("onpaginate", data)
    },
  },
  mounted() {
    this.create()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Paginator.vue